import { useContext } from "react";

import { RbacContext, type RbacContextValue } from "@/features/rbac/components/RbacContext";

/**
 * El único resolver de permisos de la aplicación.
 *
 * Nada fuera del slice `rbac` debería volver a leer `permission_admin`,
 * `type === "admin"` ni `vm_admin` para decidir si algo se muestra o se puede
 * hacer.
 *
 * @example
 * ```tsx
 * const { can } = usePermissions();
 * if (can("users:delete")) { … }
 * ```
 */
export function usePermissions(): RbacContextValue {
  const context = useContext(RbacContext);

  if (!context) {
    throw new Error("usePermissions debe usarse dentro de <RbacProvider>");
  }

  return context;
}
